import { LOCALE } from '@constants/locale';

const nf = new Intl.NumberFormat(LOCALE);
export const num = (n: number | null | undefined) => (n == null ? '–' : nf.format(n));

/** A figure in a fixed-size tile: in full up to 99.999, then "120 rb", "1,2 jt" (the full number goes in a tooltip). */
export function numShort(n: number | null | undefined): string {
  if (n == null) return '–';
  if (Math.abs(n) < 100_000) return nf.format(n);
  if (Math.abs(n) < 1_000_000) return `${nf.format(Math.floor(n / 1000))} rb`;
  return `${new Intl.NumberFormat(LOCALE, { maximumFractionDigits: 1 }).format(Math.floor(n / 100_000) / 10)} jt`;
}

/** A figure in a small round marker: in full below 1.000, then "12,3 rb", "120 rb", "1,2 jt" (full value in its name). */
export function numCompact(n: number | null | undefined): string {
  if (n == null) return '–';
  if (Math.abs(n) < 1_000) return nf.format(n);
  if (Math.abs(n) < 100_000) return `${new Intl.NumberFormat(LOCALE, { maximumFractionDigits: 1 }).format(Math.floor(n / 100) / 10)} rb`;
  return numShort(n);
}

export const bytes = (n: number) => (n < 1024 ? `${n} B` : n < 1048576 ? `${(n / 1024).toFixed(0)} KB` : `${(n / 1048576).toFixed(1)} MB`);

/** "RS" for "Ryan Saputra" (avatars). */
export const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]!.toUpperCase())
    .join('') || '?';

const rp = new Intl.NumberFormat(LOCALE, { maximumFractionDigits: 0 });
/** Rupiah as printed on a receipt: "Rp 18.000" (whole rupiah; null as "–"). */
export const rupiah = (n: number | null | undefined) => (n == null ? '–' : `Rp ${rp.format(n)}`);
